export const setPaginaServicoNaoHabilitado = (dados) => dispatch => {
    return dispatch({
        type: 'SET_SERVICO_NAO_HABILITADO_MEU_INSS',
        payload: dados,
    })
}

export const limparTituloDescricaoPagina = () => dispatch => {
    return dispatch({
        type: 'LIMPAR_SERVICO_NAO_HABILITADO_MEU_INSS'
    })
}